<mat-form-field>
  <input matInput
    class="admin-search-input"
    placeholder="{{(searchSettings ? searchSettings.placeholder : placeholder) | translate}}"
    [formControl]="searchInput" />
  <mat-icon matSuffix
    color="accent">search</mat-icon>
</mat-form-field>